var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMiconImage = function SvgMiconImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 10,
    r: 2,
    stroke: "currentcolor",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentcolor",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m3 20 7-7 8 8 4-4 7 7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentcolor",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M3 3h26v26H3z"
  })));
};
export default SvgMiconImage;